import React from 'react';
import SystemTopClass from './SystemTopClass.jsx'; 
// 割引制度
const DiscountProgram = () => {
    return (
        <>
            <div className="card mb-3 border-0">
                    <div className="row g-0">
                        <div className="col-md-12">
                            <div className="card-body">
                                <ul className="card-text">
                                    <li>ペア割引・・友人あるいは兄弟姉妹が同時に入塾すると、入塾費半額となります。</li>
                                    <li>特待生制度・・月謝が半額となります。</li>                        
                                    <li>兄弟姉妹割引・・兄弟姉妹で土佐塾に通って頂いた場合、入塾費半額、授業料・講座料は安い方を半額割引いたします。</li>
                                    <li><SystemTopClass /></li>
                                </ul>
                            </div>
                        </div>
                    </div>
            </div>
        </>
    );
};

// 特待生制度条件・・
export default DiscountProgram;